function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileContactList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_x5F_contact_x5F_list",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.71,
    y: 8.291,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.3997 10.3739)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2.224,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M12.133,9.028l-1.232-1.23c0.659-0.659,1.806-0.658,2.463,0L12.133,9.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M12.999,16.026c-0.968-0.968-0.968-2.543,0-3.511l1.414,1.414 c-0.124,0.124-0.142,0.267-0.142,0.342c0,0.074,0.018,0.218,0.142,0.341L12.999,16.026z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M14.413,13.93l-1.414-1.415l1.128-1.127L11.95,9.211l1.414-1.414l2.36,2.36 c0.025,0.026,0.049,0.052,0.071,0.08c0.58,0.661,0.577,1.659-0.011,2.315c-0.019,0.023-0.039,0.045-0.06,0.066L14.413,13.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M12.363,20.627c-4.376-4.45-4.982-9.308-3.034-11.257l1.414,1.414 c-0.924,0.925-0.693,4.638,3.046,8.44L12.363,20.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 14.908,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.2299 15.1724)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2.812
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.597,
    y: 21.178,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.7376 23.2606)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2.224,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M25.203,22.098l-1.232-1.231l1.232-1.231C25.881,20.315,25.881,21.419,25.203,22.098z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M18.729,20.729c-0.663,0-1.286-0.259-1.755-0.728l1.414-1.414 c0.124,0.123,0.267,0.142,0.341,0.142c0.075,0,0.218-0.019,0.341-0.142l1.415,1.414C20.016,20.47,19.392,20.729,18.729,20.729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M23.789,21.05l-2.176-2.176l-1.128,1.128l-1.414-1.415l1.31-1.31 c0.023-0.024,0.048-0.046,0.073-0.067c0.636-0.564,1.666-0.569,2.306-0.009c0.029,0.023,0.058,0.049,0.085,0.076l2.358,2.359 L23.789,21.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M20.637,24.726c-2.324,0-5.379-1.252-8.264-4.089l1.402-1.426 c3.803,3.739,7.516,3.969,8.44,3.046l1.414,1.414C22.944,24.356,21.898,24.726,20.637,24.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.687,
    y: 16.894,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.0527 17.1591)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2.812
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M29,32H2V0h27c1.654,0,3,1.346,3,3v26C32,30.654,30.654,32,29,32z M4,30h25c0.551,0,1-0.448,1-1V3 c0-0.552-0.449-1-1-1H4V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 9,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 13,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 17,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 21,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileContactList);
export default __webpack_public_path__ + "static/media/mobile_contact_list.2c8b39329c9cf1ac29362c6b25ae80a0.svg";
export { ForwardRef as ReactComponent };